import { render, staticRenderFns } from "./TXTRecordForm.vue?vue&type=template&id=de55b6d4&"
import script from "./TXTRecordForm.vue?vue&type=script&lang=js&"
export * from "./TXTRecordForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de55b6d4')) {
      api.createRecord('de55b6d4', component.options)
    } else {
      api.reload('de55b6d4', component.options)
    }
    module.hot.accept("./TXTRecordForm.vue?vue&type=template&id=de55b6d4&", function () {
      api.rerender('de55b6d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Domains/ZoneEditor/Records/TXTRecordForm.vue"
export default component.exports